export default __webpack_public_path__ + "static/press-65c8363539196606e3402081c6cc9a0f.png";